(() => {
  'use strict';
  if (window.smoofVectronRequestV1) return;
  window.smoofVectronRequestV1 = true;
  const init = (scope) => scope.querySelectorAll('[data-vectron-request]').forEach((section) => {
    if (section.dataset.initialized) return;
    section.dataset.initialized = 'true';
    const dialog = section.querySelector('dialog');
    const opener = section.querySelector('[data-svr-open]');
    const form = dialog.querySelector('form');
    const root = section.dataset.root;
    let previousOverflow, closeTimer;
    let closing = false;
    const open = () => {
      if (dialog.open) return;
      previousOverflow = document.documentElement.style.overflow;
      dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      (dialog.querySelector('[data-svr-confirmation]:not([hidden]) h2') || dialog.querySelector('h2')).focus({preventScroll: true});
    };
    const finishClose = () => {
      clearTimeout(closeTimer);
      closing = false;
      if (dialog.open) dialog.close();
    };
    const close = () => {
      if (!dialog.open || closing) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        finishClose();
        return;
      }
      closing = true;
      dialog.classList.add('svr__dialog--closing');
      // Keep the modal and backdrop in the top layer until the exit finishes.
      closeTimer = setTimeout(finishClose, 260);
    };
    dialog.addEventListener('animationend', (event) => {
      if (event.target === dialog && event.animationName === 'svr-dialog-out') finishClose();
    });
    dialog.addEventListener('cancel', (event) => { event.preventDefault(); close(); });
    opener.disabled = false;
    opener.addEventListener('click', open);
    section.querySelector('[data-svr-close]').addEventListener('click', close);
    dialog.addEventListener('close', () => {
      clearTimeout(closeTimer);
      closing = false;
      dialog.classList.remove('svr__dialog--closing');
      document.documentElement.style.overflow = previousOverflow || '';
      if (opener.isConnected) opener.focus({preventScroll: true});
    });
    dialog.addEventListener('click', (event) => { if (event.target === dialog) {
      const r = dialog.getBoundingClientRect();
      if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) close();
    }});
    section.addEventListener('shopify:section:unload', finishClose);
    // Presentation only: Shopify Forms keeps every field, validation and submission.
    const appForm = section.querySelector('[data-svr-app-form]');
    if (appForm) {
      const template = section.querySelector('[data-svr-forms-style]');
      if (!template) return;
      let timer, attempts = 0, disposed = false;
      const roots = new Map();
      const confirmation = dialog.querySelector('[data-svr-confirmation]');
      const originalLabel = dialog.getAttribute('aria-labelledby');
      const syncSuccess = () => {
        if (!confirmation) return;
        // Use Shopify's explicit result state, never missing fields or a submit click.
        const confirmed = Array.from(appForm.querySelectorAll('shopify-forms-embed'))
          .some((host) => host.shadowRoot?.querySelector('[data-form-root][data-current-step="success"]'));
        if (confirmed === dialog.classList.contains('svr__dialog--success')) return;
        dialog.classList.toggle('svr__dialog--success', confirmed);
        confirmation.hidden = !confirmed;
        const heading = confirmation.querySelector('h2');
        dialog.setAttribute('aria-labelledby', confirmed ? heading.id : originalLabel);
        if (dialog.open) {
          dialog.scrollTop = 0;
          (confirmed ? heading : dialog.querySelector('header h2')).focus({preventScroll: true});
        }
      };
      const discover = () => {
        if (disposed) return;
        appForm.querySelectorAll('shopify-forms-embed').forEach((host) => {
          const shadow = host.shadowRoot;
          if (!shadow || roots.has(shadow)) return;
          const style = document.createElement('style');
          style.dataset.svrFormsStyle = 'true';
          style.textContent = template.content.textContent;
          const restore = () => {
            if (disposed) return;
            if (!shadow.contains(style)) shadow.append(style);
            syncSuccess();
            shadow.querySelectorAll('button[type="submit"]').forEach((button) => {
              // Keep React's text nodes intact; decorative copies are hidden from AT.
              const label = Array.from(button.childNodes)
                .filter((node) => node.nodeType === Node.TEXT_NODE)
                .map((node) => node.textContent).join('').trim();
              if (!label) {
                button.removeAttribute('data-svr-menu-hover');
                button.querySelectorAll('[data-svr-button-label]').forEach((node) => node.remove());
                return;
              }
              ['original', 'reveal'].forEach((kind) => {
                let copy = button.querySelector(`[data-svr-button-label="${kind}"]`);
                if (!copy) {
                  copy = document.createElement('span');
                  copy.dataset.svrButtonLabel = kind;
                  copy.setAttribute('aria-hidden', 'true');
                  button.append(copy);
                }
                if (copy.textContent !== label) copy.textContent = label;
              });
              if (!button.hasAttribute('data-svr-menu-hover')) button.setAttribute('data-svr-menu-hover', '');
            });
          };
          restore();
          const observer = new MutationObserver(restore);
          observer.observe(shadow, {childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['data-current-step']});
          roots.set(shadow, observer);
        });
        syncSuccess();
      };
      const watch = new MutationObserver(discover);
      watch.observe(appForm, {childList: true, subtree: true});
      const retry = () => {
        clearTimeout(timer);
        discover();
        if (!disposed && !roots.size && attempts++ < 80) timer = setTimeout(retry, 250);
      };
      const restart = () => { attempts = 0; retry(); };
      opener.addEventListener('click', restart);
      retry();
      section.addEventListener('shopify:section:unload', () => {
        disposed = true;
        clearTimeout(timer);
        watch.disconnect();
        roots.forEach((observer) => observer.disconnect());
        opener.removeEventListener('click', restart);
      });
      return;
    }
    if (!form) return;
    const sample = form.querySelector('[data-svr-sample]');
    const partner = form.querySelector('[data-svr-partner]');
    const choiceError = form.querySelector('[data-svr-choice-error]');
    form.action = root + 'contact#' + form.id;
    // The native Shopify contact form owns validation, spam challenge and delivery.
    // Only non-personal choice flags travel in the return fragment.
    if (sample && partner) {
      const validate = () => {
        const valid = (sample.checked && !sample.disabled) || partner.checked;
        partner.setCustomValidity(valid ? '' : section.dataset.choiceError);
        if (valid) choiceError.hidden = true;
        return valid;
      };
      sample.addEventListener('change', validate);
      partner.addEventListener('change', validate);
      partner.addEventListener('invalid', () => { choiceError.hidden = false; });
      const pendingKey = 'svr-pending:' + form.id;
      let pending;
      try { pending = JSON.parse(sessionStorage.getItem(pendingKey)); } catch (_) {}
      if (pending && pending.path === location.pathname && Date.now() - pending.time < 3600000) {
        sample.checked = pending.sample && !sample.disabled;
        partner.checked = pending.partner;
      }
      validate();
      form.addEventListener('submit', (event) => {
        if (!validate()) { event.preventDefault(); choiceError.hidden = false; partner.reportValidity(); return; }
        const selectedSample = sample.checked && !sample.disabled;
        const token = Date.now().toString(36) + Math.random().toString(36).slice(2,8);
        const marker = form.id + '--' + (selectedSample ? 'sample' : 'partner') + '--' + token;
        const returnInput = form.querySelector('[name="return_to"]');
        if (!returnInput) { event.preventDefault(); return; }
        // Shopify uses this success-only redirect to render posted_successfully?.
        returnInput.value = location.pathname + '?contact_posted=true#' + marker;
        form.action = root + 'contact#' + marker;
        try { sessionStorage.setItem(pendingKey, JSON.stringify({path:location.pathname,time:Date.now(),sample:selectedSample,partner:partner.checked})); } catch (_) {}
      });
      if (form.querySelector('[data-svr-errors]') && (pending || location.hash.startsWith('#' + form.id))) open();
    }
    const success = form.querySelector('[data-svr-success]');
    const marker = location.hash.slice(1);
    // Shopify may return the plain form anchor or omit the fragment.
    // Never show success from a fragment or pending submission alone.
    const ownResult = !marker || marker === form.id || marker.startsWith(form.id + '--sample--') || marker.startsWith(form.id + '--partner--');
    if (success && ownResult) {
      open();
      try { sessionStorage.removeItem('svr-pending:' + form.id); } catch (_) {}
    }
  });
  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
